module.exports = __webpack_public_path__ + "img/盘查核查工作流程.bb684944.png";